<template>
  <div
    id="chatinput"
    style="bottom: 0; right: 0; left: 0"
    :style="{ position: isMobile ? 'fixed' : 'absolute' }"
  >
    <slot name="header"></slot>
    <div style="background: white; border-top: 1px solid #eee; position: relative">
      <form v-on:submit.prevent="noop">
        <!-- AIS/Hippo Hold Chat -->
        <v-layout v-if="hippopage.includes(livechat.pageid) && holdmsg == 'done'">
          <v-flex v-if="holdstatus" style="color: #ff8d89"
            ><div style="padding: 10px">Holded by {{ holdadminId }}</div></v-flex
          >
          <v-btn v-else outline color="primary" @click="onHoldChat">HOLD CHAT</v-btn>
        </v-layout>
        <v-layout>
          <v-avatar size="30" class="ma-1">
            <img
              @error="onError"
              :src="
                'https://graph.facebook.com/' +
                $store.state.livechat.pageid +
                '/picture?width=100&height=100&SameSite=None'
              "
              style="border: 1px solid #eee"
            />
          </v-avatar>
          <v-flex class="pa-1">
            <autoresize-textarea
              ref="livechat_input"
              v-model="text"
              rows="1"
              placeholder="Type message"
              :class="{
                black_input_font:
                  [
                    '102052945584054',
                    '106855151601601',
                    '111901618984646',
                    '200701213291845'
                  ].includes(livechat.pageid) || ['cityfresh'].includes(livechat.theme)
              }"
              style="
                resize: none;
                border: 1px solid #eee;
                padding: 5px;
                border-radius: 5px;
                outline: 0px;
                background: none;
                display: inline-block;
              "
              @pressEnter="onEnter()"
              @onPaste="onPaste"
            ></autoresize-textarea>
          </v-flex>

          <v-flex
            shrink
            class="text-xs-right"
            style="
              white-space: nowrap;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
            "
          >
            <template v-if="isShowChatTool">
              <span>
                <v-btn
                  icon
                  ripple
                  small
                  @click="isShowChatTool = false"
                  class="pa-0 ma-0"
                  v-tooltip.top="'Minimize'"
                >
                  <em class="fas fa-chevron-right" />
                </v-btn>
              </span>
              <span v-if="$store.state.toacustomerpage.includes(selectedBot.pageid)">
                <v-btn icon v-tooltip.top="'Products'" @click="showToaProduct = true">
                  <em class="fas fa-shopping-cart" />
                </v-btn>
              </span>
              <!-- Emoji -->
              <span v-if="['oab'].includes(selectedBot.theme) && app == 'facebook'">
                <v-btn icon style="margin: 0" v-tooltip.top="'Emoji'" @click="showEmoji = true">
                  <em class="far fa-smile-wink" style="font-size: 22px" />
                </v-btn>
              </span>
              <!-- Send image -->
              <template v-if="['cityfresh'].includes(selectedBot.type)">
                <span>
                  <v-btn
                    icon
                    style="margin: 0"
                    v-tooltip.top="'Send Image'"
                    @click="showUploadImg = true"
                  >
                    <v-icon class="outlined">photo_size_select_actual</v-icon>
                  </v-btn>
                  <UploadMultipleImage
                    v-model="showUploadImg"
                    @handleSendImages="handleSendMultipleImages"
                  />
                </span>
              </template>
              <template v-else>
                <v-dialog v-model="showUploadImg" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn icon style="margin: 0" v-tooltip.top="'Send Image'" v-on="on">
                        <v-icon class="outlined">photo_size_select_actual</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card>
                    <div class="text-xs-right">
                      <v-btn @click="showUploadImg = false" fab flat color="primary" small>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <v-card-text v-if="showUploadImg">
                      <div>
                        <uploadfile
                          ref="answer"
                          v-model="image_url"
                          @onUploaded="onUploaded"
                          v-validate
                          :multiple="true"
                        ></uploadfile>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </template>
              <v-dialog v-model="showUploadFile" max-width="700">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Send File'" v-on="on">
                      <em style="font-size: 20px" class="fas fa-file-alt" />
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <div class="text-xs-right">
                    <v-btn @click="showUploadFile = false" fab flat color="primary" small>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text v-if="showUploadFile">
                    <div>
                      <uploadalltype
                        ref="answer"
                        v-model="file_url"
                        @onUploaded="onUploadedFile($event)"
                        v-validate
                        :multiple="true"
                      ></uploadalltype>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <span v-if="app == 'line'">
                <v-btn icon style="margin: 0" v-tooltip.top="'Sticker'" @click="showSticker = true">
                  <v-icon class="outlined">face</v-icon>
                </v-btn>
              </span>
            </template>
            <template v-else>
              <span>
                <v-btn
                  icon
                  ripple
                  small
                  @click="isShowChatTool = true"
                  class="pa-0 ma-0"
                  v-tooltip.top="'Maximize'"
                >
                  <em class="fas fa-chevron-left" />
                </v-btn>
              </span>
            </template>

            <template v-if="currentTheme == 'universalutilities'">
              <!-- Send reply message -->
              <span>
                <v-dialog v-model="showIntent" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn icon style="margin: 0" v-tooltip.top="'Send'" v-on="on">
                        <v-icon class="outlined">forum</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card>
                    <div class="text-xs-right">
                      <v-btn @click="showIntent = false" fab flat color="primary" small>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <v-card-text>
                      <intent
                        :livechat="true"
                        :key="$store.state.livechat.pageid"
                        :pageid="$store.state.livechat.pageid"
                        :showDefault="false"
                        @sendToLivechat="sendMessage"
                      ></intent>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <v-btn
                  depressed
                  fab
                  color="primary"
                  small
                  :loading="IsSending"
                  :disabled="!enableSend"
                  @click="clickSendBtn"
                  v-tooltip.top="
                    loadingLinePushMessageCount
                      ? 'Loading...'
                      : messageAvailableCount !== false
                      ? `จำนวนที่เคยส่ง ${messageAvailableCount} ข้อความ`
                      : 'Send'
                  "
                >
                  <em class="fa fa-send" />
                </v-btn>
              </span>
            </template>
            <template v-else>
              <span>
                <v-dialog v-model="showIntent" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn icon style="margin: 0" v-tooltip.top="'Quick Message'" v-on="on">
                        <v-icon class="outlined">forum</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card>
                    <v-card-text v-if="showIntent">
                      <div class="text-xs-right">
                        <v-btn @click="showIntent = false" fab depressed color="primary" small>
                          <v-icon>close</v-icon>
                        </v-btn>
                      </div>
                      <intent
                        :livechat="true"
                        :key="$store.state.livechat.pageid"
                        :pageid="$store.state.livechat.pageid"
                        :showDefault="false"
                        @sendToLivechat="sendMessage"
                      ></intent>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
              <span>
                <v-btn
                  ref="sendBtn"
                  depressed
                  fab
                  color="primary"
                  small
                  :disabled="!enableSend"
                  :loading="IsSending"
                  @click="clickSendBtn"
                  v-tooltip.top="'Send'"
                >
                  <em class="fa fa-send" />
                </v-btn>
              </span>
            </template>
          </v-flex>
        </v-layout>
      </form>

      <sticker-list v-model="showSticker" @sendSticker="sendSticker"></sticker-list>
      <emoji-list v-model="showEmoji" @sendEmoji="sendEmoji"></emoji-list>
      <ToaProductsDialog
        v-if="showToaProduct"
        v-model="showToaProduct"
        @onSendGroup="onSendGroup"
      ></ToaProductsDialog>

      <v-dialog v-model="showHoldDialog" width="570px" height="270px">
        <v-card>
          <div
            class="text-center"
            style="display: flex; flex-direction: column; justify-content: center"
          >
            <div style="font-size: 24px; margin: 30px">
              การสนทนานี้ถูก Hold ไว้โดย {{ holdadminId }}<br />
              ยืนยันการตอบกลับหรือไม่
            </div>
            <div style="margin-bottom: 20px">
              <v-btn color="primary" @click="onConfirmSendMessage(holdaction)">ยืนยัน</v-btn>
              <v-btn style="background: #d9d9d9; color: black" @click="showHoldDialog = false"
                >ยกเลิก</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar v-model="snackbar.show" bottom right :timeout="3000" :color="'error'">
      {{ snackbar.message || 'Connection fail. Please try again' }}
      <v-btn flat fab dark small @click="snackbar.show = false">
        <v-icon small color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import AutoresizeTextarea from './AutoresizeTextarea'
import { mapGetters } from 'vuex'
import Intent from '@/components/view/intent/Intent'
import uploadfile from '@/components/elements/uploadfile'
import uploadalltype from '@/components/elements/uploadalltype'
import UploadMultipleImage from '@/components/elements/UploadMultipleImage/UploadMultipleImage'
import moment from 'moment'
import StickerList from '@/components/elements/StickerList'
import ToaProductsDialog from './ToaProductsDialog.vue'
import UploadSingleFile from '@/components/elements/UploadSingleFile.js'
import EmojiList from '@/components/elements/EmojiList'

import api from '@/api'
import allInOneChatApi from '@/api/all-in-one-chat'

import { handleResponse, handleApiError } from '@/api/util'

export default {
  props: ['value', 'app', 'hasNewMessage', 'refreshChatInput'],
  mixins: [UploadSingleFile],
  data: function () {
    return {
      type: 'text',
      text: '',
      enableSend: false,
      user: this.value,
      isMobile: false,
      showIntent: false,
      showUploadImg: false,
      showToaProduct: false,
      image_url: null,
      showUploadFile: false,
      file_url: null,
      showSticker: false,
      showEmoji: false,
      isreply: false,
      holdstatus: false,
      holdadminId: null,
      hippopage: ['100825145655476', '103267601317473', '208321456497173', '113700147637887'],
      confirmSend: [],
      showHoldDialog: false,
      holdaction: null,
      holdmsg: '',
      IsSending: false,
      snackbar: {
        show: false,
        message: ''
      },
      isShowChatTool: false
    }
  },
  computed: {
    ...mapGetters({
      livechat: 'livechat',
      selectedBot: 'selectedBot',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      botlist: 'botlist',
      livechat: 'livechat',
      currentUserTicket: 'currentUserTicket'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    isUnlock() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && this.$store.state.livechat.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },
    messageAvailableCount: function () {
      var vm = this
      if (vm.loadingLinePushMessageCount || vm.currentTheme != 'universalutilities') {
        return false
      }
      var area = vm.linePushMessageCount.find((el) => {
        return el.uu_areaname == vm.user.uu_areaname
      })
      if (area) {
        return area.count
      } else {
        return false
      }
    },
    newMessageArive() {
      if (this.newMessage) {
        if (this.newMessage.admin != '0' || this.newMessage.bot != '0') {
          this.holdstatus = false
          this.confirmSend = []
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  components: {
    AutoresizeTextarea,
    Intent,
    uploadfile,
    uploadalltype,
    StickerList,
    ToaProductsDialog,
    EmojiList,
    UploadMultipleImage
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  async mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })

    // AIS Hippo Hold Chat
    if (this.hippopage.includes(this.livechat.pageid)) {
      await this.GetHoldChat('check')
    }
  },
  methods: {
    onEnter() {
      if (![...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
        if (!this.isMobile) this.$refs.sendBtn.click()
      }
    },
    async onPaste(evt) {
      const clipboardData = evt.clipboardData || evt.originalEvent.clipboardData
      const items = clipboardData.items
      for (let index in items) {
        const item = items[index]
        if (item.kind === 'string') {
          if (clipboardData.getData('text') && clipboardData.getData('text').trim() != '') {
            const text = clipboardData.getData('text').trim()

            const cursorPosition = this.$refs['livechat_input'].$el.selectionStart
            this.text = [
              this.text.slice(0, cursorPosition),
              text,
              this.text.slice(cursorPosition)
            ].join('')
            evt.target.value = this.text
            await this.$nextTick()
            this.$refs['livechat_input'].$el.selectionEnd = cursorPosition + text.length
            this.enableSend = true
          } else {
            this.enableSend = false
          }
          return false
        } else if (item.kind === 'file') {
          const blob = item.getAsFile()
          const base64 = await this.renderImage(blob)
          const result = await this.$swal.fire({
            title: 'Do you want to send this image?',
            html: `<img src="${base64}" style="max-height: 250px; max-width: 400px;">`,
            showCancelButton: true,
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })

          if (result.value) {
            this.$store.dispatch('loading')
            try {
              const url = await this.validateFile([blob])
              if (url) {
                this.onUploaded([url])
              }
            } catch (error) {
              console.error(error)
            }
            this.$store.dispatch('loading')
          }
          return false
        }
      }
    },
    renderImage(blob) {
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader()
          reader.onload = function (event) {
            resolve(event.target.result)
          }
          reader.readAsDataURL(blob)
        } catch (error) {
          reject(error)
        }
      })
    },
    onSendGroup(group) {
      this.$swal
        .fire({
          text: 'ยืนยันการส่งสินค้า ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.$store.dispatch('loading')
            api.toaSendProductToCustomerByAdmin(
              {
                userid: this.$store.state.livechat.currentUser.userid,
                pageid: this.selectedBot.pageid,
                group: group
              },
              (err, response) => {
                this.$store.dispatch('loading')
                this.$emit('loadmessage')
              }
            )
            this.showToaProduct = false
          }
        })
    },
    clickSendBtn() {
      if (!this.text || this.text.trim() == '') return false
      let data = {
        a_val: JSON.stringify([[{ text: this.text, type: 'text' }]]),
        type: 'json'
      }
      this.sendMessage(data)
    },
    chatboxEnter(event) {},
    sendSticker({ packageid, stickerid }) {
      let data = {
        a_val: `[[{ "stickerid": ${stickerid}, "type": "sticker", "packageid": ${packageid} }]]`,
        type: 'json'
      }

      this.sendMessage(data)
    },
    sendEmoji({ emoji }) {
      var vm = this
      vm.text += emoji.data
    },
    onUploadedFile(url) {
      this.enableSend = true
      var files = [[]]

      if (typeof url == 'string') {
        if (url.indexOf('.mp4') != -1) {
          files[0].push({ source: url, type: 'video' })
        } else {
          files[0].push({
            data: [
              {
                buttons: [{ title: 'Download', type: 'web_url', url: url }],
                image_url: 'https://cms.zwiz.app/static/img/assets/icon/file.png',
                subtitle: '',
                title: ''
              }
            ],
            ratio: 'square',
            type: 'generic'
          })
        }
      } else {
        url.forEach((el) => {
          if (el.indexOf('.mp4') != -1) {
            files[0].push({ source: el, type: 'video' })
          } else {
            files[0].push({
              data: [
                {
                  buttons: [{ title: 'Download', type: 'web_url', url: el }],
                  image_url: 'https://cms.zwiz.app/static/img/assets/icon/file.png',
                  subtitle: '',
                  title: ''
                }
              ],
              ratio: 'square',
              type: 'generic'
            })
          }
        })
      }
      let data = {
        a_val: JSON.stringify(files),
        type: 'json'
      }

      this.sendMessage(data)
      this.file_url = null
      this.showUploadFile = false
    },
    onUploaded(url) {
      this.enableSend = true
      var images = [[]]
      if (typeof url == String) {
        images[0].push({ image_url: url, type: 'image' })
      } else {
        url.forEach((el) => {
          images[0].push({ image_url: el, type: 'image' })
        })
      }
      let data = {
        a_val: JSON.stringify(images),
        type: 'json'
      }

      this.sendMessage(data)
      this.showUploadImg = false
      this.image_url = null
    },
    async handleSendMultipleImages(payload) {
      let sendPromise = []
      if (payload.onComplete) {
        payload.onComplete()
      }
      const chunkSize = 5
      for (let i = 0; i < payload.messages.length; i += chunkSize) {
        const chunk = payload.messages.slice(i, i + chunkSize)
        sendPromise.push(
          this.sendMessage({
            a_val: JSON.stringify([[...chunk]]),
            type: 'json'
          })
        )
      }
      Promise.all(sendPromise)
    },
    newline() {
      this.text = '${this.text}\n'
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    async sendMessage(event) {
      this.IsSending = true
      this.showIntent = false
      // let isIntent = event && event.type == 'intent'
      let vm = this
      try {
        const livechat = this.livechat
        if (!livechat) {
          this.IsSending = false
          return false
        }
        const pageid = livechat.pageid
        const currentUser = livechat.currentUser

        if (!pageid && !currentUser) {
          this.IsSending = false
          return false
        }
        const userid = currentUser.userid
        const adminid = vm.$store.state.userid
        const assigngroupid = vm.$store.state.admingroupid
        const assignsubgroupid = vm.$store.state.adminsubgroupid

        var bot = this.botlist.find((el) => {
          return el.pageid == pageid
        })
        if (!bot) {
          this.IsSending = false
          return false
        }
        var type = event.a_type ? event.a_type /* from quickmessage */ : event.type

        var dataChatlog = {
          pageid,
          userid,
          adminid,
          limit: 5,
          offset: 0
        }

        try {
          const response = await allInOneChatApi.getChatLog({ data: dataChatlog })
          await handleResponse(response)
          const responseData = response.data
          let messagevalue = vm.text
          if (
            this.livechat.app == 'line' &&
            type == 'json' &&
            event.line_val &&
            event.line_val.length > 8
          ) {
            messagevalue = event.line_val
          } else if (
            this.livechat.app == 'facebook' &&
            type == 'json' &&
            event.fb_val &&
            event.fb_val.length > 8
          ) {
            messagevalue = event.fb_val
          } else if (type == 'json') {
            messagevalue = event.a_val
          } else {
            messagevalue = vm.text
          }

          let data = {
            pageid,
            userid,
            app: livechat.app,
            adminid,
            messagetype: type,
            status: currentUser.status,
            messagevalue,
            page_access_token: bot.page_access_token,
            assigngroupid,
            assignsubgroupid
          }

          if (responseData.data) {
            var timestamp = responseData.data[0].timestamp
            var duration = moment.duration(moment().diff(timestamp)).seconds() //คำนวณเวลา
            var messagetype = responseData.data[0].messagetype

            if (messagetype == 'noreply' && duration < 1200) {
              data = {
                ...data,
                isreply: true //optional
              }
            }
          }

          if (event.a_type) {
            Object.assign(data, {
              context_in: event.context_in,
              context_out: event.context_out,
              userstatus: event.userstatus,
              usertags: event.usertags
            })
          }

          if (event.quick_reply) {
            Object.assign(data, { quick_reply: event.quick_reply })
          }

          let message = {
            answerby: 'admin',
            id: new Date().getTime(),
            messagedata:
              type == 'json'
                ? messagevalue.length > 0
                  ? JSON.stringify(JSON.parse(messagevalue)[0])
                  : event.a_val
                : vm.text,
            messagetype: type,
            pageid,
            timestamp: new Date(),
            userid,
            adminid
          }

          if (event.intentname) {
            data.intent = event.intentname
            message.intent = data.intent
          }

          if (
            this.$store.state.prudentialPage.includes(pageid) ||
            this.$store.state.prudentialRealPage.includes(pageid)
          ) {
            if (event) {
              data.fb_val = event.fb_val
              data.fb_quick_reply = event.fb_quick_reply
              data.line_val = event.line_val
              data.line_quick_reply = event.line_quick_reply
              data.quick_reply = event.quick_reply
            }
          }

          // AIS/Hippo hold chat function
          if (this.hippopage.includes(pageid)) {
            let IsConfirmSend = this.confirmSend.filter(
              (f) => f.pageId == pageid && f.userId == userid
            )
            if (!IsConfirmSend.length > 0) {
              await this.GetHoldChat('sendmessage')
              if (!this.holdstatus) {
                this.HoldChatOnly()
              }

              if (this.showHoldDialog) {
                this.IsSending = false
                return
              }
            }
          }

          vm.$emit('onSendMessage', message)
          vm.text = ''

          try {
            await api.sendMessage(data)

            // KFC - Close case when last ticket was pending or answered
            // Check from event (intent - quick message)
            // Check only intent as "E1" and "Z1"
            if (
              event.hasOwnProperty('intentname') &&
              event.intentstatus &&
              ((['102052945584054', '106855151601601'].includes(pageid) &&
                event.intentname &&
                event.intentname.startsWith('.E1')) ||
                event.intentname.startsWith('.Z1'))
            ) {
              vm.$store.dispatch('loading')
              let payload = (payload = {
                pageId: pageid,
                userId: userid
              })
              if (event.intentname && event.intentname.startsWith('.E1')) {
                payload.action = 'closed'
              } else {
                payload.action = 'cancelled'
              }

              await api.CloseLastestTicket(payload)
              vm.$root.$emit('loadTicket')
              vm.$root.$emit('loadLivechatUser')
              vm.$store.commit('SET_TICKET_LOADING', true)
              this.$set(this.$store.state.livechat, 'currentUser', null)
              vm.$store.dispatch('loading')
            }

            if (event.a_type /* from quickmessage */) {
              await vm.$store.dispatch('loadLatestUsers', {
                type: vm.$store.state.livechat.type
              })
            }
            if (vm.selectedBot.theme == 'universalutilities') {
              vm.$store.dispatch('loadLinePushMessageCount', {
                dateform: moment().startOf('month').format('YYYY-MM-DD'),
                dateto: moment().endOf('month').format('YYYY-MM-DD')
              })
            }

            vm.updateReadchat()
          } catch (error) {
            this.snackbar.message = error ? error.toString() : 'ไม่สามารถส่งข้อความได้'
            this.snackbar.show = true
            console.error('livechat+input', error)
          }
        } catch (error) {
          await handleApiError(error)
        }
      } catch (error) {
        console.error(error)
        vm.IsSending = false
        return false
      }

      vm.IsSending = false
    },
    async GetHoldChat(action) {
      // Check hold
      let payload = {
        pageId: this.livechat.pageid,
        userId: this.livechat.currentUser.userid,
        adminid: this.$store.state.userid
      }
      let result = await api.GetHippoHoldChat(payload)
      if (result) {
        if (result.holdstatus) {
          if (result.data.adminhold != this.$store.state.userid) {
            this.holdstatus = true
            this.holdadminId = result.data.adminhold

            if (action == 'sendmessage') {
              this.holdaction = 'send'
              this.showHoldDialog = true
              return
            }
          } else {
            this.holdstatus = true
            this.holdadminId = result.data.adminhold
          }
        } else {
          this.holdstatus = false
          this.holdadminId = ''
        }
        this.holdmsg = 'done'
      }
    },
    onConfirmSendMessage(action) {
      this.confirmSend.push({
        pageId: this.livechat.pageid,
        userId: this.livechat.currentUser.userid
      })
      if (action == 'send') {
        this.clickSendBtn()
        this.showHoldDialog = false
        this.holdaction = ''
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 960
    },
    async updateReadchat() {
      if (
        // this.$aston.astonpages.includes(this.$store.state.livechat.pageid) &&
        this.$store.state.livechatadminreadpage.includes(this.$store.state.livechat.pageid)
      ) {
        await api.adminreadchat({
          adminid: this.$store.state.userid,
          userid: this.user.userid,
          pageid: this.selectedBot.pageid
        })

        await this.$nextTick()
        this.user.adminread = true
        this.$store.commit('SET_LIVECHAT_USER', this.user)
        this.$forceUpdate()
      }
    },
    async onHoldChat() {
      // Save hold
      await this.GetHoldChat('check')
      if (!this.holdstatus) {
        this.HoldChatOnly()
      }
    },
    async HoldChatOnly() {
      let payload = {
        pageId: this.livechat.pageid,
        userId: this.livechat.currentUser.userid,
        adminId: this.$store.state.userid
      }
      let result = await api.SetHippoHoldChat(payload)
      this.holdstatus = true
      this.holdadminId = result.data.adminhold
      if (!result.setstatus) {
        this.holdaction = 'check'
      }
    }
  },
  watch: {
    text: function (newVal, oldVal) {
      if (newVal && newVal.trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    value: function (newVal, oldVal) {
      this.user = this.value
    },
    hasNewMessage(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.hasNewMessage) {
          this.holdstatus = false
          this.holdadminId = ''
        }
      }
    },
    refreshChatInput(newVal, oldVal) {
      if (newVal != oldVal) {
        this.holdstatus = this.refreshChatInput.holdstatus
        this.adminhold = this.refreshChatInput.adminhold
      }
    }
  }
}
</script>

<style scoped>
.black_input_font {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatinput.vue